import { AuthService } from 'src/app/services/auth.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add auth header with token if user is logged in and which request requires token headers
        const token = this.authService.tokenValue;
        const apiUrls = [
            environment.apiUrl + '/user',
            environment.apiUrl + '/admin',
            environment.apiUrl + '/series',
            environment.apiUrl + '/payment',
            environment.apiUrl + '/dashboard',
            environment.apiUrl + '/countries',
            environment.apiUrl + '/user_devices',
            environment.apiUrl + '/billing_history',
            environment.apiUrl + '/marketing_collateral',
            environment.apiUrl + '/check_voucher_update_user',
            environment.apiUrl + '/resources',
        ];

        // Checks if url is a valid one
        let isApiUrl = false;
        apiUrls.forEach(url => {
            if (request.url.startsWith(url)) {
                isApiUrl = true;
            }
        });

        if (token && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `${token}`
                }
            });
        }

        return next.handle(request);
    }
}
